import { render, staticRenderFns } from "./SortedDescIcon.vue?vue&type=template&id=4a1a5d2d&"
import script from "./SortedDescIcon.vue?vue&type=script&lang=js&"
export * from "./SortedDescIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports